import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { Login } from './components/login/Login';
import { App } from './components/app/App';
import { Home } from './components/app/home/Home';
import { Setting } from './components/app/home/Setting';
import { PasswordRecovery } from './components/passwordRecovery/PasswordRecovery';
import { LinkSent } from './components/passwordRecovery/LinkSent';
import { ChangePassword } from './components/passwordRecovery/ChangePassword';
import { InvalidRequest } from './components/passwordRecovery/InvalidRequest';
import { SuccessfulKeyChange } from './components/passwordRecovery/SuccessfulKeyChange';
import { View404Component } from './components/app/view404/view404.component';
import { View401Component } from './components/app/view401/view401.component';
import { AuthGuard } from './providers/guards/auth.guard';
import { ExternalComponent } from './components/app/external/external.component';
import { TestComponent } from 'components/app/test/Test.component';
import { Lobby } from 'components/lobby/Lobby';
import { ProfileLobby } from 'components/lobby/profileLobby/ProfileLobby';


const appRoutes: Routes = [
    {
        path: 'login',
        component: Login
    },
    {
        path: 'home',
        component: Lobby,
        canActivate: [AuthGuard]
    },
    {
        path: 'home/profile',
        component: ProfileLobby,
        // loadChildren: 'components/lobby/profileLobby/ProfileLobbyModule#ProfileLobbyModule',
        canActivate: [AuthGuard]
    },
    {
       path: 'app',
       component: App,
       canActivate: [AuthGuard],
       children: [
           {
               path: 'home',
               component: Home
           },
        //    {
        //         path: 'test',
        //         component: TestComponent
        //     },
        //    {
        //        path: 'abc',
        //        component: Setting
        //    },
           {
                path: 'security',
                loadChildren: 'components/security/SecurityModule#SecurityModule'
           },
           {
                path: 'support',
                loadChildren: 'components/support/companies/SupportCompanyModule#SupportCompanyModule'
            },
            {
                path: 'storage',
                loadChildren: 'components/allStorage/AllStorageModule#AllStorageModule'
            },
            {
                path: 'profile',
                loadChildren: 'components/myProfile/MyProfileModule#MyProfileModule'
            },
            {
                path: 'company',
                loadChildren: 'components/company/CompanyModule#CompanyModule'
            },
            {
                path: 'products',
                loadChildren: 'components/products/ProductsModule#ProductsModule'
            },
            {
                path: 'metavisor',
                loadChildren: 'components/metavisor/MetavisorModule#MetavisorModule'
            },
            {
                path: 'notifications',
                loadChildren: 'components/notifications/NotificationsModule#NotificationsModule'
            },
            {
                path: 'external',
                component: ExternalComponent
            },
           {
                path: '401',
                component: View401Component
            },
            {
                path: '404',
                component: View404Component
            },
            {path: '**', redirectTo: '404'}
        ]
    },
    {
        path: 'password/recovery',
        component: PasswordRecovery
    },
    {
        path: 'password/recovery/linkSent',
        component: LinkSent
    },
    {
        path: 'password/recovery/change',
        component: ChangePassword
    },
    {
        path: 'password/recovery/invalidRequest',
        component: InvalidRequest
    },
    {
        path: 'password/recovery/successfulKeyChange',
        component: SuccessfulKeyChange
    },
    // {
    //     path: '',
    //     redirectTo: '/login',
    //     pathMatch: 'full'
    // },
    {
        path: '404',
        canActivate: [AuthGuard],
        component: View404Component
    },
    {
        path: '401',
        canActivate: [AuthGuard],
        component: View401Component
    },
    {path: '**', redirectTo: '/login'}
];

@NgModule({
    imports: [RouterModule.forRoot(appRoutes)],
    exports: [RouterModule],
    providers: []
})

export class RoutingModule {}
